module.exports = __webpack_public_path__ + "img/teatro_della_scala.7dafe37a.png";